import { Group, Namespace } from "./model";

// Translations: UK English

export default {
  [Namespace.DEFAULT]: {
    [Group.DEFAULT]: {
      organization: "Organisation",
      reportingYearTooltip:
        "You must select an Organisation before filtering by Reporting Year",
    },
  },

  [Namespace.ANALYTICS]: {
    [Group.DEFAULT]: {
      subTitle: "Deep dive into your organisation’s carbon footprint.",
    },
  },

  [Namespace.HOME]: {
    [Group.DEFAULT]: {
      welcomeText: ` Manage your organisation’s Carbon Accounting requirements with ease
        through Minimum’s Emissions Data Platform. Access and submit data, track
        progress, analyse your footprint, and generate reports seamlessly.
        Explore the features below to learn how our platform can help enable a
        more sustainable future for your organisation.`,
    },
  },

  [Namespace.COLLECTION_STATUS]: {
    [Group.DEFAULT]: {
      subTitle:
        "Track your organisation’s collection progress – whether the data is being manually submitted or collected automatically via an integration.",
      header: "Track submitted items for your organisation’s submissions.",
    },
  },

  [Namespace.EMISSIONS]: {
    [Group.DEFAULT]: {
      emissionsSubtitle:
        "Displaying data of your organisation’s carbon footprint.",
    },

    [Group.FILTERS]: {
      dataSettingsTitle: "Organisation structure as of {{date}}",
    },

    [Group.SETTINGS]: {
      organizationStructure: "Organisation Structure As Of",
      organizationStructureDate: "Use my organisation structure as of date",
    },

    [Group.CONSOLIDATION]: {
      inheritedDescription:
        "The original emission was inherited by <heading>{{entity}}</heading> after being consolidated through the following Entities in your organisation:",
    },
  },

  [Namespace.HUB]: {
    [Group.TASKS]: {
      selectOrganisation: "Select organisation",
    },
  },

  [Namespace.DOCUMENTS]: {
    [Group.DEFAULT]: {
      subTitle:
        "Access and manage documents and certificates for your organisation",
    },
    [Group.UPLOAD]: {
      referenceHelperText:
        "This name is referenced by at least one transformer for this organisation.",
    },
  },
};
